import { render } from "./UserAuth.vue?vue&type=template&id=643464ef"
import script from "./UserAuth.vue?vue&type=script&lang=js"
export * from "./UserAuth.vue?vue&type=script&lang=js"

import "./UserAuth.vue?vue&type=style&index=0&id=643464ef&lang=scss"
script.render = render

export default script